import React from 'react';
import { IconButton, Tooltip } from '@material-ui/core';
import useTranslations from '../../../../hooks/useTranslations';
import styled from 'styled-components/macro';
import EmailDialogEngine, {
  EMAIL_DIALOG_TYPES
} from '../../../engine/EmailDialogEngine';
import SubjectIcon from '@material-ui/icons/Subject';

const EditTemplateBtnContainer = styled.span`
  margin-left: 0.8rem;
  line-height: 3;

  ${({ $containerCSS }) => $containerCSS}
`;

const ActionEmailTemplateEditorView = props => {
  const t = useTranslations();

  return (
    <>
      <EditTemplateBtnContainer $containerCSS={props.containerCSS}>
        <Tooltip title={t('automaions.wizard.actions.email.template.edit')}>
          <IconButton size="small" onClick={props.onOpenEmailDialogClicked}>
            <SubjectIcon />
          </IconButton>
        </Tooltip>
      </EditTemplateBtnContainer>

      <EmailDialogEngine
        open={props.isEmailDialogOpen}
        handleClose={props.onEmailDialogClosed}
        type={EMAIL_DIALOG_TYPES.TEMPLATE}
        templateId={props.templateId}
        allowNewTemplateCreation
        setTemplateId={props.setTemplateId}
        reducerListener={props.onEmailReducerChange}
        additionalPlaceHolders={props.fieldPlaceHolders}
        additionalPlaceHoldersProps={{
          placeholder: 'Insert field placeholder'
        }}
        additionalSaveTemplateBodyParams={{
          assetType: 'automations'
        }}
        forceNewTemplateCreation={props.forceTemplateCreation}
        {...props.emailDialogProps}
      />
    </>
  );
};

export default ActionEmailTemplateEditorView;
